import { useState, useEffect } from 'react';
import { Table } from 'antd';

// Table component
const TenantTable = ({ tableColumns, initialData, centerContent = false }) => {
  const [dataSource, setDataSource] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if (initialData) setDataSource(initialData);
    if (tableColumns) setColumns(tableColumns);
  }, [initialData, tableColumns]);

  return (
    <div className="w-full h-auto">
      <Table 
        dataSource={dataSource} 
        columns={columns} 
        pagination={false}
        bordered={false}
        className="w-full"
        scroll={{ x: 'max-content' }}
        components={{
          header: {
            cell: props => (
              <th 
                {...props} 
                style={{ 
                  background: 'linear-gradient(360deg, rgba(135, 63, 226, 0.1) 0%, rgba(154, 197, 255, 0.23) 100%)',
                  textAlign: centerContent ? 'center' : 'left'
                }}
                className="!text-[#4772F1] !font-[700] !py-3 sm:!text-[14px] !text-[12px] font-inter"
              />
            ),
          },
          body: {
            row: props => (
              <tr 
                {...props} 
                className="bg-[#FFFFFF] border-b border-[#CACACA]" 
                style={{ 
                  height: '48px',
                  borderBottomWidth: '1px'
                }}
              />
            ),
            cell: props => (
              <td 
                {...props} 
                className={`px-3 sm:px-6 text-[12px] sm:text-[14px] font-inter font-normal text-[#707070] ${centerContent ? 'text-center' : ''}`}
                style={{ 
                  height: '46px',
                  textAlign: centerContent ? 'center' : 'left'
                }}
              />
            )
          }
        }}
      />
    </div>
  );
};

const TableSection = ({ 
  header, 
  underlineWidth, 
  tableData, 
  tableColumns, 
  centerContent = false,
  centerTable = true,
  containerWidth = "1140px",
  tableWidth = "100%",
  tablePadding = "",
  children
}) => {
  return (
    <div className="relative">
      <div className="relative inline-block">
        <h1 className="font-poppins text-[#242527] font-semibold text-[15px] md:text-[20px] leading-none tracking-normal  mt-[32px] md:mt-[32px]">
          {header}
        </h1>
        <div 
          className="absolute left-0 mt-1 w-full" 
          style={{ 
            background: 'linear-gradient(90deg, #60BBEE -2.22%, #2387C0 67.22%)',
            height: '2px'
          }}
        ></div>
      </div>
      <div className="mt-[22px] sm:mt-[24px]"> {/* Container for both table and children */}
        <div 
          className="rounded-t-[10px] bg-[#84B2CD21] w-full max-w-full overflow-hidden" 
        >
          {/* Table container with center alignment */}
          <div className="w-full flex justify-center p-3 sm:p-5 overflow-x-auto">
            <div 
              className="min-w-full sm:min-w-0 w-full"
              style={{ 
                width: window.innerWidth >= 640 ? tableWidth : '100%'
              }}
            >
              <TenantTable 
                initialData={tableData} 
                tableColumns={tableColumns}
                centerContent={centerContent}
              />
            </div>
          </div>
          
          {/* Children container aligned with table start */}
          {children && (
            <div className="w-full flex justify-center sm:justify-start sm:ml-[-185px] pb-3 sm:pb-5 px-4 sm:px-0">
              <div className="w-full sm:w-auto flex justify-center sm:justify-start">
                {children}
              </div>
            </div>
          )}
        </div> 
      </div>
    </div>
  );
};

export { TenantTable, TableSection };
export default TenantTable;